export const shouldConnectFirebaseEmulators = (
  isDevelopment: boolean,
  enabled: string | undefined,
  hostname: string,
): boolean => isDevelopment && enabled === 'true' &&
  (hostname === 'localhost' || hostname === '127.0.0.1');
